const areas = [
  'Elk Grove Village',
  'Wood Dale',
  'Bensenville',
  'Mount Prospect',
  'Des Plaines',
  'Addison',
  'Roselle',
  'Arlington Heights',
  'Rolling Meadows',
  'Schiller Park',
  'Schaumburg',
  'Bloomingdale',
  'Prospect Heights',
  'Franklin Park',
  'Park Ridge',
];

export default function ServiceAreas() {
  return (
    <section id="areas" className="bg-charcoal-900 py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — map */}
          <div className="rounded-2xl overflow-hidden h-[440px] border border-gold/10">
            <iframe
              title="Hometown Painters — Elk Grove Village, IL Service Area"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47570.43!2d-87.9970!3d42.0011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fb0e4e2c11b43%3A0x7b7e6aea2d1de2c4!2sElk%20Grove%20Village%2C%20IL!5e0!3m2!1sen!2sus!4v1711000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'grayscale(30%) contrast(1.1)' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Right — content */}
          <div>
            <span className="font-sans text-gold text-xs tracking-[0.3em] uppercase">Where We Work</span>
            <h2 className="font-serif text-warm-white text-4xl md:text-5xl mt-3 mb-4 leading-tight">
              Serving Elk Grove Village<br />&amp; Surrounding Communities
            </h2>
            <div className="w-20 h-0.5 bg-gold mb-6" />
            <p className="font-sans text-warm-muted text-sm leading-relaxed mb-8">
              From Elk Grove Village to the broader Chicago suburbs, Hometown Painters delivers
              interior, exterior, and commercial painting services built for Illinois conditions —
              durable coatings that hold up season after season.
            </p>

            <div className="grid grid-cols-3 gap-y-3 gap-x-4 mb-8">
              {areas.map((area) => (
                <div key={area} className="flex items-center gap-2">
                  <span className="block w-1.5 h-1.5 bg-gold rounded-full shrink-0" />
                  <span className="font-sans text-warm-muted text-sm">{area}</span>
                </div>
              ))}
            </div>

            <a
              href="#quote"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 border border-gold text-gold font-sans text-sm px-6 py-3 rounded-full hover:bg-gold hover:text-charcoal-900 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Get a Quote in Your Area
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" style={{ fontSize: '14px' }} />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
